import { csHttp } from '@/utils/http';
import { API_BASE_URL } from '@/config/env';

// 接口TS类型置顶
export interface LoginForm {
    account: string;
    password: string;
}

/** OAuth2 Token响应 - 客服端 */
export interface OAuth2TokenRes {
    access_token: string;
    refresh_token: string;
    expires_in: number;
    token_type: string;
}

export interface UploadAvatarRes {
    avatarUrl: string;
}

// ==================== 接口常量 ====================

/** OAuth2 Token 端点（客服端使用 grant_type=customer_service） */
const CS_OAUTH2_TOKEN_URL = `${API_BASE_URL}/auth/oauth2/token`;

const UPLOAD_AVATAR_API = `${API_BASE_URL}/ai/cs-api/v1/staff/user/avatar`;

// ==================== 客服端 OAuth2 客户端凭据 ====================

const CS_CLIENT_ID = 'cs-app';
const CS_CLIENT_SECRET = 'cs-secret';

/** Base64 编码的客户端凭据（用于 Authorization: Basic xxx） */
const CS_CLIENT_CREDENTIALS = btoa(`${CS_CLIENT_ID}:${CS_CLIENT_SECRET}`);

// ==================== 接口函数 ====================

/** 客服端 OAuth2 登录（grant_type=customer_service） */
export function csOAuth2LoginApi(data: LoginForm) {
    console.log('csOAuth2LoginApi', CS_OAUTH2_TOKEN_URL);
    // OAuth2 表单编码格式，使用 axios 直接发送
    return csHttp.post<OAuth2TokenRes>(
        CS_OAUTH2_TOKEN_URL,
        `grant_type=customer_service&account=${encodeURIComponent(data.account)}&password=${encodeURIComponent(data.password)}`,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Basic ${CS_CLIENT_CREDENTIALS}`,
            },
        }
    );
}

/** 修改头像（传入已上传的头像URL） */
export function updateAvatarApi(data: UploadAvatarRes) {
    return csHttp.put<UploadAvatarRes>(UPLOAD_AVATAR_API, data);
}

// 退出登录不再需要服务端接口（策略A：前端清空Token）
// logoutApi 已移除，退出逻辑在前端直接 clearCsAuth()
